import React from 'react';

/** Stacked-layers icon used in settings card headers. */
export default function LayersIcon({ size = 28, color = 'currentColor', ...props }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
      style={{ color: 'var(--ca-primary)' }}
      {...props}
    >
      <path
        d="M12 3 3 8l9 5 9-5-9-5Z"
        stroke={color}
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path
        d="M3 12.5 12 17.5l9-5"
        stroke={color}
        strokeWidth="1.6"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path
        d="M3 16.5 12 21.5l9-5"
        stroke={color}
        strokeWidth="1.6"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  );
}
